<template>
  <div class="tab-section" v-if="$store.getters.currentMerchant">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InnerTabs',
};
</script>

<style scoped lang="scss">
.tab {
  width: 100%;
}
.tab-section {
  margin-bottom: 1rem;
  position: relative;
  display: flex;
  font-display: row;
  justify-content: start;
  align-items: center;
}
.tab-item {
  transition: all 0.2s linear;
  box-sizing: content-box;
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 35px;
  line-height: 32px;
  padding: 0 8px;
  font-size: 1rem;
  margin-left: 5px;
  background: #ffffff;
  color: #657789;
  border-radius: 0.4rem;
  margin-top: 4px;
  &:hover {
    color: #3699ff;
  }
  //   &:after {
  //     display: block;
  //     content: " ";
  //     position: absolute;
  //     top: 0;
  //     height: 100%;
  //     width: 44px;
  //     background-color: #FFF;
  //     transition: all 250ms ease;
  // }
  &::after {
    border-radius: 8px 0 0 0;
  }
  &::after {
    left: -24px;
    transform: skew(-30deg, 0deg);
    box-shadow: rgb(0 0 0 / 10%) -3px 2px 5px, inset rgb(255 255 255 / 9%) 1px 0;
  }
}
.outlined-card-title {
  position: absolute;
  top: -12px;
  background: #fff;
  padding: 0 1rem;
  right: 20px;
}
.tab-is-active {
  border-top: 3px solid #3699ff;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  border-left: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: -1px;
  background: white;
}
</style>
